import { useRef } from "react";

const NotFound = () => {
    const modalRef = useRef();
    const modalOutClick = (e) => {
        if(modalRef.current === e.target){
            check();
        }
    }

    const check = () => {
        window.history.back();
    }

    return(
        <div className="valid" ref={modalRef} onClick={(e)=>{modalOutClick(e)}}>
            <div className="valid-modal">
                <div className="valid-modal-all">
                    <p className="valid-modal-font">
                        페이지 주소가 올바르지 않습니다.
                        <br></br>
                        다시 한번 확인해주세요.
                    </p>
                    <div className="valid-modal-button">
                        <button className="valid-modal-check" onClick={()=>{check()}}>
                            확인
                        </button>
                    </div>
                </div>
            </div>            
        </div>        
    )
}

export default NotFound;